<template>
  <div class="bg-default wrapper">
    <!-- Navbar -->
    <base-nav
      class="navbar-top navbar-horizontal navbar-light bg-white"
      containerClasses="px-4 container"
      expand
    >
      <router-link slot="brand" class="navbar-brand" to="/">
        <img src="/img/brand/logo_stars_black.png" class="custom-logo" />
      </router-link>

      <template v-slot="{ closeMenu }">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="/img/brand/logo_stars_black.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <button
                type="button"
                @click="closeMenu"
                class="navbar-toggler"
                aria-label="Toggle sidenav"
              >
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Navbar items -->
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link nav-link-icon" to="/register">
              <i class="fas fa-user-circle"></i>
              <span class="nav-link-inner--text">Cadastro</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link nav-link-icon" to="/login">
              <i class="fas fa-sign-in-alt"></i>
              <span class="nav-link-inner--text">Login</span>
            </router-link>
          </li>
        </ul>
      </template>
    </base-nav>
    <!-- Header -->
    <div class="header mt-lg-7 mt-5">
      <div class="container">
        <div class="header-body text-center mb-3">
          <div class="row">
            <div class="col-12">
              <h1 class="text-white">Bem-vindo!</h1>
              <p class="text-lead text-white">
                Página de acesso ao Portal Stars
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container main-content">
      <slide-y-up-transition mode="out-in" origin="center top">
        <router-view></router-view>
      </slide-y-up-transition>
    </div>
    <footer class="footer px-4 bg-default">
      <div class="row align-items-center justify-content-lg-between px-4">
        <div class="col-lg-6 mt-2 mt-lg-0">
          <div class="copyright text-center text-lg-left text-muted">
            © {{ year }}
            Powered by
            <a
              href="https://starsaceleradora.com.br/"
              class="font-weight-bold text-orange"
              target="_blank"
              >Stars Aceleradora</a
            >
          </div>
        </div>
        <div class="col-lg-6 mt-0">
          <ul
            class="nav nav-footer justify-content-center justify-content-lg-end"
          >
            <li class="nav-item">
              <a
                href="https://www.facebook.com/AceleradoraStars/"
                class="nav-link"
                target="_blank"
                ><i class="fab fa-facebook text-lg"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                href="https://www.instagram.com/starsaceleradora/?hl=pt-br"
                class="nav-link"
                target="_blank"
                ><i class="fab fa-instagram text-lg"></i
              ></a>
            </li>
            <li class="nav-item">
              <a
                href="https://www.linkedin.com/company/starsaceleradora?originalSubdomain=br"
                class="nav-link"
                target="_blank"
                ><i class="fab fa-linkedin text-lg"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: "auth-layout",
  components: {
    SlideYUpTransition,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      showMenu: false,
    };
  },
};
</script>
<style scoped>
.footer .nav-link {
  padding: 0 0.75rem;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  min-height: 50px;
  padding: 0;
  line-height: 50px;
}
.main-content {
  margin-bottom: 9rem;
}

.wrapper {
  min-height: 100%;
  min-width: 100%;
  position: absolute;
}

.navbar-horizontal .navbar-brand img.custom-logo {
  height: 50px;
}
</style>
<style>
html {
  position: relative;
  min-height: 100%;
}
</style>
